<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path fill="#52A500" d="M13.056 1.703h-.723V0H10.89v1.703H5.11V0H3.667v1.703h-.723c-.801 0-1.444.675-1.444 1.5V13.5c0 .832.65 1.5 1.444 1.5h10.112c.801 0 1.444-.668 1.444-1.5V3.203c0-.825-.643-1.5-1.444-1.5Zm0 11.797H2.944V6.531h10.112V13.5Zm0-8.469H2.944V3.203h10.112v1.828Z"/>
  </svg>
</template>
